import { render, staticRenderFns } from "./product-statement-report.vue?vue&type=template&id=7127fb48&"
import script from "./product-statement-report.vue?vue&type=script&lang=ts&"
export * from "./product-statement-report.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports